import { render, staticRenderFns } from "./NotificationsAskBloc.vue?vue&type=template&id=4ddf78b9&scoped=true&"
import script from "./NotificationsAskBloc.vue?vue&type=script&lang=js&"
export * from "./NotificationsAskBloc.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsAskBloc.vue?vue&type=style&index=0&id=4ddf78b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ddf78b9",
  null
  
)

export default component.exports